import { useState, useEffect } from 'react';

import { type SupportedFileType, SupportedFileTypes } from './types'
import MediaHelper from '../../utils/mediaHelper'

interface UseFilePreviewOptions {
  src: string
  filename?: string
  mimetype?: string
}

const getSupportedFileType = (
  src: string,
  filename: string,
  mimetype: string
): SupportedFileType => {
  if (mimetype) {
    if (MediaHelper.isPdfMimetype(mimetype)) {
      return SupportedFileTypes.PDF
    } else if (MediaHelper.isImageMimetype(mimetype)) {
      return SupportedFileTypes.IMAGE
    }
  }

  if (filename) {
    if (MediaHelper.isPdfFilename(filename)) {
      return SupportedFileTypes.PDF
    } else if (MediaHelper.isImageFilename(filename)) {
      return SupportedFileTypes.IMAGE
    }
  }

  if (src) {
    if (MediaHelper.isPdfFilename(src)) {
      return SupportedFileTypes.PDF
    } else if (MediaHelper.isImageFilename(src)) {
      return SupportedFileTypes.IMAGE
    }
  }

  return null
}

export const useFilePreview = ({
  src,
  filename,
  mimetype,
}: UseFilePreviewOptions) => {
  const [isLoading, setIsLoading] = useState(false)
  const [fileType, setFileType] = useState<SupportedFileType>(
    getSupportedFileType(src, filename, mimetype)
  )

  useEffect(() => {
    if (!src) {
      setIsLoading(false)
      return
    }

    const supportedFileType = getSupportedFileType(src, filename, mimetype)

    switch (supportedFileType) {
      case SupportedFileTypes.PDF:
        setFileType(SupportedFileTypes.PDF)
        setIsLoading(false)
        break
      case SupportedFileTypes.IMAGE:
      default:
        setIsLoading(true)

        MediaHelper.createImage(src)
          .then(() => {
            setFileType(SupportedFileTypes.IMAGE)
            setIsLoading(false)
          })
          .catch(() => {
            setFileType(null)
            setIsLoading(false)
          })
        break
    }
  }, [src, filename, mimetype])

  return {
    isLoading,
    fileType,
  }
}
